<template>
    <div>
        <portal-target name="dropdown" slim />

        <mobile-menu :showUserMenu="showUserMenu"
            :menu="menu"
            :profile="profile"
            @showDropdownMenus="showDropdownMenus"
            @hideDropdownMenus="hideDropdownMenus"
            @navigateTo="navigateTo"
            ref="mobileMenu"
        />

        <!-- Static sidebar for desktop -->
        <div class="hidden xl:flex xl:w-56 xl:flex-col xl:fixed xl:inset-y-0 sidebar">
            <!-- Sidebar component, swap this element with another sidebar if you like -->
            <div class="flex-1 flex flex-col min-h-0 bg-gray-800">
                <div class="flex-1 flex flex-col pt-4 pb-4 overflow-y-auto mb-4">
                    <div class="flex items-center justify-between flex-shrink-0 px-4 gap-x-2">
                        <Link href="/">
                            <logo class="fill-white" width="120" height="28" :image="this.$page.props.tenant.frontend.logo_file_white" />
                        </Link>
                        <span class="text-white font-medium text-xl">AWA</span>
                    </div>
                    <main-menu :menu="menu" @navigateTo="navigateTo" ref="mainMenu"/>
                </div>
                <div class="flex-shrink-0">
                    <div
                        class="text-red-500 bg-white group flex items-center m-2 mb-4  p-2 text-base font-medium"
                        v-if="!isProd(this.$page.props.global.env)">
                        <span class="w-8 text-center mr-2">
                            <icon name="warning-triangle" class="h-6 w-6 text-red-500"></icon>
                        </span>
                        <span class="staging-info">Staging</span>
                    </div>
                    <div class="flex bg-gray-700 p-4">
                        <profile :profile="profile"></profile>
                    </div>
                </div>
            </div>
        </div>
        <div class="xl:pl-64 flex-col flex-1 content">
            <div class="sticky top-0 z-10 xl:hidden p-1 sm:sm:p-3 bg-gray-100 flex justify-between items-center">
                <button type="button"
                        @click="showDropdownMenus()"
                        class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span class="sr-only">{{$t('shared.mobile_menu.open_sidebar')}}</span>
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
                <Link href="/" class="mx-5">
                    <logo class="fill-white" width="120" height="28" :image="this.$page.props.tenant.frontend.logo_file"/>
                </Link>
            </div>
            <main id="main">
                <div class="px-2 xl:pl-0 xl:pr-8 xl:py-6 main-content">
                    <flash-messages />
                    <slot />
                </div>
            </main>
        </div>
    </div>
</template>


<script>
import MobileMenu from "@/Shared/MobileMenu";
import Dropdown from '@/Shared/Dropdown'
import FlashMessages from '@/Shared/FlashMessages'
import Icon from '@/Shared/Icon'
import Logo from '@/Shared/Logo'
import MainMenu from '@/Shared/MainMenu'
import { Link } from '@inertiajs/vue2';
import Profile from "@/Shared/Profile";
import Environment from "../mixins/Environment";

export default {
    components: {
        MobileMenu,
        Dropdown,
        FlashMessages,
        Icon,
        Logo,
        Profile,
        MainMenu,
        Link
    },
    mixins: [Environment],
    data() {
        return {
            showUserMenu: false,
            profile: {
                fullName: this.$page.props.auth.user.first_name + ' ' + this.$page.props.auth.user.last_name,
                profileImage: null
            },
            menu: this.getMenuItems(),
            cmsUrl: this.$page.props.global.cms_url
        }
    },
    methods: {
        getMenuItems() {
            let indent = 0;
            let items = [];

            items.push({ icon: 'dashboard', name: 'dashboard', route: 'dashboard', label: this.$t('shared.main_menu.dashboard'), indent: indent});

            if (this.acl().auctionListView === true) {
                items.push({ icon: 'auctions', name: 'auctions', route: 'auctions', label: this.$t('shared.main_menu.auctions'), indent: indent});
            }

            if (this.acl().campaignView === true) {
                items.push({ icon: 'template', name: 'campaigns_overview', route: 'campaigns.list', label: this.$t('shared.main_menu.overview')});
            }

            if (this.acl().auctionInsightsView === true) {
                items.push({ icon: 'auctions', name: 'insights.auctions', route: 'insights.auctions', label: this.$t('shared.main_menu.insights'), indent: indent});
            }

            if (this.acl().userInsightsView === true) {
                items.push({ icon: 'eye', name: 'insights.audience', route: 'insights.audience', label: this.$t('shared.main_menu.users'), indent: indent});
            }

            if (this.acl().campaignView === true) {
                items.push({ icon: 'lock', name: 'misc.userlocks', route: 'misc.userlocks', label: this.$t('shared.main_menu.locks')});
            }

            /*
            if (this.acl().travelAuctionsPlanning === true) {
                items.push({ icon: 'edit', name: 'planning', route: 'auctions.planning', label: this.$t('shared.main_menu.planning'), indent: indent});
            }

            if (this.acl().travelAuctionsControlpanel === true) {
                items.push({ icon: 'gamepad', name: 'controlpanel', route: 'controlpanel', label: this.$t('shared.main_menu.control_panel'), indent: indent});
            }

            if (this.acl().travelAnalytics === true) {
                items.push({ icon: 'analytics', name: 'analytics', route: 'auctions.analytics', label: this.$t('shared.main_menu.analytics'), indent: indent});
            }
            if (this.acl().travelSettings === true) {
                items.push({ icon: 'control', iconClass: 'rotate-90', name: 'settings', route: 'settings', label: this.$t('shared.main_menu.settings'), indent: indent});
            }
            */
            return items;
        },
        showDropdownMenus() {
            this.showUserMenu = true;
        },
        hideDropdownMenus() {
            this.showUserMenu = false
        },
        navigateTo() {
            this.hideDropdownMenus();
        },
        getPath() {
            const url = new URL(window.location.href);
            return url.origin + url.pathname;
        },
        acl: function() {
            return this.$page.props.global.acl;
        }
    },
    beforeUpdate() {
        let newMenuItems = [];
        let path = this.getPath();
        let route = this.route;
        this.menu.forEach((item, index) => {
            this.menu[index].active = path === route(item.route);
            let newItem = JSON.parse(JSON.stringify(this.menu[index]));
            newMenuItems.push(newItem);
        });
        this.menu = newMenuItems;
    }
}
</script>
